export default "__VITE_ASSET__BABJa1Gi__"